import { getConfig } from '@b2ag/micro-front-tools'

type ObjectRoute = {
  path: string
  query: Record<string, string | boolean>
  hash: string | undefined
}

const url = {
  methods: {
    getQueryParameters(link) {
      // link is like 'https://www.aladin.farm/search?hierarchicalMenu[categoriesLevel0][0]=Santé du végétal&hierarchicalMenu[categoriesLevel0][1]=Molluscicides'
      // or https://www.aladin.farm/search?hierarchicalMenu[categoriesLevel0][0]=Santé du végétal&refinementList[crops][1]=Vigne&refinementList[crops][2]=Vigne de table&refinementList[crops][3]=Vigne-mère
      const emptyQuery = ''
      const queryStrings = link && link.split('?')[1] ? link.split('?')[1] : emptyQuery

      const queryObject = {}
      const urlParameters = queryStrings.split('&')
      if (urlParameters) {
        urlParameters.forEach((parameter) => {
          const [key, value] = parameter.split('=')
          if (key) {
            queryObject[decodeURIComponent(key)] = value !== undefined ? decodeURIComponent(value) : true
          }
        })
      }
      return queryObject
    },
    compareUrl(linkA, linkB, compareFn) {
      if (!linkA || !linkB) return false
      try {
        const linkAUrlObject = new URL(linkA)
        const linkBUrlObject = new URL(linkB)
        return compareFn(linkAUrlObject, linkBUrlObject)
      } catch (_: any) {
        return false
      }
    },
    checkDifferentOrigin(urlObjectA, urlObjectB) {
      return urlObjectA.origin !== urlObjectB.origin
    },
    checkSameCurrentPath(urlObjectA, urlObjectB) {
      return urlObjectA.origin === urlObjectB.origin && urlObjectA.pathname === urlObjectB.pathname
    },
    isExternalLink(link, currentLocation) {
      if (this.isInternalLink(link) || this.isHash(link)) return false
      return this.compareUrl(link, currentLocation, this.checkDifferentOrigin)
    },
    isCurrentPath(link, currentLocation) {
      if (this.isHash(link)) return true
      return this.compareUrl(link, currentLocation, this.checkSameCurrentPath)
    },
    isHash(link) {
      return link.startsWith('#')
    },
    isInternalLink(link) {
      return link.startsWith('/')
    },
    getFullPathname(link) {
      if (!link) return ''
      const linkUrl = new URL(link)
      const fullPathname = `${linkUrl.href.replace(linkUrl.origin, '')}`
      return fullPathname
    },
    getHash(link) {
      if (!link) return ''
      if (this.isHash(link)) return link
      try {
        const linkUrl = new URL(link)
        return linkUrl.hash
      } catch (_: any) {
        return link
      }
    },
    urlToRoute(link) {
      if (link) {
        if (link.name || link.path) {
          return link
        }

        if (this.isInternalLink(link)) {
          const completeUrl = new URL(this.completeUrl(link))

          const urlObject: ObjectRoute = {
            path: completeUrl.pathname,
            query: this.getQueryParameters(link),
            hash: undefined,
          }

          if (completeUrl.hash) {
            urlObject.hash = completeUrl.hash
          }

          return urlObject
        }

        try {
          const urlObject = new URL(link)
          const objectRoute: ObjectRoute = {
            path: urlObject.pathname,
            query: this.getQueryParameters(link),
            hash: undefined,
          }

          if (urlObject.hash) {
            objectRoute.hash = urlObject.hash
          }
          return objectRoute
        } catch (_: any) {
          return { name: 'home' }
        }
      }
      return { name: 'home' }
    },
    completeUrl(link) {
      const baseUrl = getConfig('BASE_URL')
      const origin = baseUrl.includes('localhost') ? 'http://' + baseUrl : 'https://' + baseUrl

      if (!link) {
        return origin
      }
      if (link.startsWith('/') || link.startsWith('#')) {
        return `${origin}${link}`
      }
      return link
    },
  },
}

/*
 * Adds 'https:' to a URL if it doesn't already have a protocol.
 */
export function addHTTPSinBlankUrl(testedUrl?: string) {
  return (testedUrl && !testedUrl.startsWith('http') && `https:${testedUrl}`) || testedUrl
}

export default url
